import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { AppState } from 'src/app/store/app.states';
import { getUserInfo } from 'src/app/store/selector/selector';
import { take } from 'rxjs/operators';

declare var bootstrap: any;
declare var $: any;

@Component({
  selector: 'app-subscription-update',
  templateUrl: './subscription-update.component.html',
  styleUrls: ['./subscription-update.component.scss']
})
export class SubscriptionUpdateComponent implements OnInit {
  user:any;
  plans:any;
  canceling=false;
  pausing=false;
  resuming=false;
  updating=false;
  selectedplan:any="";
  errorMessage="";
  oldsub="";
  constructor(public webApi: WebapiService,private store: Store<AppState>, private toastrService: ToastrService,public router: Router) {
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  hideModal(){
    if(this.oldsub){
      this.selectedplan=this.oldsub
    }
    $('#subscription-update-modal').modal('hide');
  }

  getPlans(role){
    this.errorMessage="";
    this.webApi.getPlans(role).subscribe((data: any) => {
      if (data.success) {
        let dataplans=data.plans;
        if(this.user.role=='choreographer'){
          this.plans = dataplans;
          for(let plan of this.plans){
              if(plan.code == this.user?.plan?.subscription_code){
                this.selectedplan=plan.stripe_plan_id
                this.oldsub = plan.stripe_plan_id
              }
          }
        }else{
          this.plans = [];
          let count=0;
          for(let i=0; i<dataplans.length;i++){
            if(dataplans[i].title.indexOf('Novice-Median')!=-1){
              if(!this.plans['0']){
                this.plans['0']=[];
              }
              this.plans['0'][count]=[];
              this.plans['0'][count]['title']=dataplans[i].title
              this.plans['0'][count]['plan']=dataplans[i]
              this.plans['0'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
              if(!this.plans['1']){
                this.plans['1']=[];
              }
              this.plans['1'][count]=[];
              this.plans['1'][count]['title']=dataplans[i].title
              this.plans['1'][count]['plan']=dataplans[i]
              this.plans['1'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
              if(!this.plans['2']){
                this.plans['2']=[];
              }
              this.plans['2'][count]=[];
              this.plans['2'][count]['title']=dataplans[i].title
              this.plans['2'][count]['plan']=dataplans[i]
              this.plans['2'][count]['index']=i
            }
            count++;
          }

          if(this.plans['0']){
            this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
          }
          
          if(this.plans['1']){
            this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
          }

          if(this.plans['2']){
            this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
          }

          this.plans = this.plans.filter((val:any)=>{return val});
          for(let plan of this.plans){
            for(let subplan of plan){
              if(subplan.plan.code == this.user?.plan?.subscription_code){
                this.selectedplan=subplan.plan.stripe_plan_id
                this.oldsub = subplan.plan.stripe_plan_id
              }
            }
          }
          
        }


        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        // this.toastrService.error(data.message);
        this.errorMessage=data.message;
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  
  getUserData(){
    this.webApi.setLoader(true)

    this.store.pipe(select(getUserInfo)).subscribe(data=>{
      this.user = data
      this.webApi.setLoader(false)
      if(this.webApi.isLoggedIn()){
        this.getPlans(this.user['role'])
      }
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //     this.getPlans(this.user['role'])
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }

  updateSubscription(){
    if(!this.selectedplan){
      this.toastrService.error("Please select a plan");
      return
    }
    if(this.oldsub == this.selectedplan){
      this.toastrService.error("Plan is already subscribed");
      return
    }
    if(!this.updating){
      this.updating=true;
      let params = {
        "subscription_id": this.user.plan.subscription_id,
        "new_plan": this.selectedplan
      }
      this.webApi.updateSubscription(params).subscribe((data: any) => {
        if(data.success){
          this.toastrService.success(data.message);
          setTimeout(()=>{
            window.location.reload();
          },1000)
        }else{
          this.toastrService.error(data.message);
        }
        this.updating=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.updating=false;
      });
    }
  }

  purchaseSubscription(){
    if(!this.selectedplan){
      this.toastrService.error("Please select a plan");
    }
    if(!this.updating){
      this.updating=true;
      let params = {
        "new_plan": this.selectedplan
      }
      this.webApi.purchaseSubscription(params).subscribe((data: any) => {
        if(data.success){
          this.toastrService.success(data.message);
          if(data.redirecturl && data.redirecturl!=""){
            window.location.href=data.redirecturl;
          }
        }else{
          this.toastrService.error(data.message);
        }
        this.updating=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.updating=false;
      });
    }
  }

  cancelSubscription(subscribeid){
    if(!this.canceling){
      this.canceling=true;
      this.webApi.cancelSubscription({subscription_id:subscribeid}).subscribe((data: any) => {
        if(data.success){
          $('#subscription-update-modal').modal('hide');
          //this.router.navigateByUrl('/');
          this.toastrService.success(data.message);
          setTimeout(()=>{
            window.location.reload();
          },1000)
        }else{
          this.toastrService.error(data.message);
        }
        this.canceling = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
      });
    }
  }

  pauseSubscription(subscribeid){
    if(!this.pausing){
      this.pausing=true;
      this.webApi.pauseSubscription({subscription_id:subscribeid}).subscribe((data: any) => {
        if(data.success){
          $('#subscription-update-modal').modal('hide');
          
          this.toastrService.success(data.message);
          setTimeout(()=>{
            window.location.reload();
          },1000)
        }else{
          this.toastrService.error(data.message);
        }
        this.pausing = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
      });
    }
  }

  period(period){
    if(period == "MONTH" || period == "Month"){
      return "Monthly"
    }else if(period == "YEAR" || period == "Year"){
      return "Yearly"
    }else{
      return period;
    }
  }

  resumeSubscription(subscribeid){
    if(!this.resuming){
      this.resuming=true;
      this.webApi.resumeSubscription({subscription_id:subscribeid}).subscribe((data: any) => {
        if(data.success){
          $('#subscription-update-modal').modal('hide');
          
          this.toastrService.success(data.message);
          setTimeout(()=>{
            window.location.reload();
          },1000)
        }else{
          this.toastrService.error(data.message);
        }
        this.resuming = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
      });
    }
  }
  
}
